import {
  Box,
  Button,
  Checkbox,
  Fade,
  Grid,
  IconButton,
  Popper,
  styled,
  Tooltip,
  tooltipClasses,
  Typography,
  useMediaQuery,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import {
  bgColor15,
  blackColor,
  blackShade05,
  blackShade19,
  blackShade23,
  blueColor04,
  greyColor40,
  greyColor41,
  greyColor42,
  greyColor50,
  greyColor8,
  heroSectionText,
  logoImgborder,
  mobilePrimary,
  oldPriceColor,
  outOfStockColor,
  whiteColor,
} from "../../../configs/styles/muiThemes";
import { textOneLines } from "../../../utils/styles";
import { getColorChip, getOrderStatusText } from "../../../utils/helper";
import { calculatePercentageOff } from "../../../utils/validationHelper";
import moment from "moment";
import DateWithTooltip from "./DateWithTooltip";

const MultiPushProductCard = ({
  isSelected,
  onProductSelect,
  loader,
  productImg,
  productName,
  originalPrice,
  salePrice,
  ondcEnabled,
  availability,
  lastUpdateDate,
  lastImportDate,
  tabValue,
  onPushProduct,
  index,
  isAllSelected,
  selectAllProducts,
  isSynced,
}) => {
  const matches = useMediaQuery((theme) => theme.breakpoints.up("md"));

  const [isSyncRequired, setIsSyncRequired] = useState(false);

  const predictSyncRequired = () => {
    const updatedData = lastUpdateDate ? moment(lastUpdateDate) : null;
    const importData = lastImportDate ? moment(lastImportDate) : null;

    if (updatedData && importData) {
      if (updatedData.isAfter(importData)) {
        // console.log("djcdjcbdjbcdkjbnckjbn_____isSyncRequired__:", {
        //   lastUpdateDate,
        //   lastImportDate,
        // });
        setIsSyncRequired(true);
      }
    }
  };

  useEffect(() => {
    predictSyncRequired();

    return () => {};
  }, [lastImportDate]);

  return (
    <Box
      sx={{
        bgcolor: whiteColor,
        padding: index === 0 && !matches ? "0 0 12px" : "12px 0",
        borderBottom: `1px solid ${greyColor41}`,
        borderRadius: { xs: "6px", md: "0px" },
        mb: { xs: 1.5, md: 0 },
      }}
    >
      {index === 0 && !matches && (
        <Box sx={styles.mobileSelectAllBox}>
          <Checkbox
            checked={isAllSelected}
            onChange={({ target }) => {
              selectAllProducts();
            }}
            sx={styles.checkbox}
            disabled={loader}
          />
          <Box sx={{ fontSize: 13, fontWeight: 500, color: blackShade23 }}>
            Select All Products
          </Box>
        </Box>
      )}

      <Grid container rowSpacing={{ xs: 1, md: 0 }}>
        <Grid item xs={3} md={1.1}>
          <Box
            display="flex"
            alignItems="flex-start"
            gap={{ xs: 1.5, md: 2 }}
            pl={2}
          >
            <Checkbox
              sx={{ ...styles.checkbox, mt: 1 }}
              checked={isSelected}
              onChange={onProductSelect}
              disabled={loader}
            />

            <Box sx={styles.imgBox}>
              <Box component="img" src={productImg} sx={styles.imgContainer} />
            </Box>
          </Box>
        </Grid>

        <Grid item xs={9} md={4.7}>
          <Box pl={2}>
            <Typography
              sx={{
                ...textOneLines,
                fontSize: 12.5,
                fontWeight: 600,
                color: blackShade19,
              }}
            >
              {productName}
            </Typography>

            <Box display="flex" alignItems="center" gap={2}>
              <PriceInfo originalPrice={originalPrice} salePrice={salePrice} />

              <Box display="flex" alignItems="center" gap={1}>
                <Typography fontSize={11.5} fontWeight={500} color={blackColor}>
                  ONDC Enabled:{" "}
                </Typography>

                <Box
                  display="flex"
                  alignItems={{ xs: "flex-start", md: "center" }}
                  justifyContent={{ xs: "flex-start", md: "center" }}
                  // pl={2}
                >
                  <Box
                    sx={styles.statusChip(
                      getColorChip(ondcEnabled === "yes" ? "yes" : "no")
                    )}
                  >
                    {getOrderStatusText(ondcEnabled === "yes" ? "yes" : "no")}
                  </Box>
                </Box>
              </Box>

              <Box display="flex" alignItems="center" gap={1}>
                <Typography fontSize={11.5} fontWeight={500} color={blackColor}>
                  Availability:{" "}
                </Typography>
                <Box
                  display="flex"
                  alignItems={{ xs: "flex-start", md: "center" }}
                  justifyContent={{ xs: "flex-start", md: "center" }}
                  // pl={2}
                >
                  <Box
                    sx={styles.statusChip(
                      getColorChip(availability ? "yes" : "no")
                    )}
                  >
                    {getOrderStatusText(availability ? "yes" : "no")}
                  </Box>
                </Box>
              </Box>
            </Box>
          </Box>
        </Grid>

        {/* {matches && (
          <Grid item xs={12} md={1.9}>
            <PriceInfo originalPrice={originalPrice} salePrice={salePrice} />
          </Grid>
        )} */}

        {/* {matches && (
          <Grid item xs={12} md={1.3}>
            <Box
              display="flex"
              alignItems={{ xs: "flex-start", md: "center" }}
              justifyContent={{ xs: "flex-start", md: "center" }}
              // pl={2}
            >
              <Box
                sx={styles.statusChip(
                  getColorChip(ondcEnabled === "yes" ? "yes" : "no")
                )}
              >
                {getOrderStatusText(ondcEnabled === "yes" ? "yes" : "no")}
              </Box>
            </Box>
          </Grid>
        )} */}

        {!matches && (
          <Grid item xs={6}>
            <Typography
              variant="body1"
              color={bgColor15}
              fontSize={12}
              lineHeight="20px"
              fontWeight={400}
              display="inline"
              pl={2}
            >
              {`ONDC Enabled: `}{" "}
              <span
                style={{
                  fontSize: 12,
                  fontWeight: 500,
                  color: ondcEnabled === "yes" ? "#27bd72" : "#e53935",
                  marginLeft: "6px",
                }}
              >
                {ondcEnabled === "yes" ? "Yes" : "No"}
              </span>
            </Typography>
          </Grid>
        )}

        {/* {matches && (
          <Grid item xs={12} md={1.15}>
            <Box
              display="flex"
              alignItems={{ xs: "flex-start", md: "center" }}
              justifyContent={{ xs: "flex-start", md: "center" }}
              // pl={2}
            >
              <Box
                sx={styles.statusChip(
                  getColorChip(availability  ? "yes" : "no")
                )}
              >
                {getOrderStatusText(availability  ? "yes" : "no")}
              </Box>
            </Box>
          </Grid>
        )} */}

        {!matches && (
          <Grid item xs={6}>
            <Typography
              variant="body1"
              color={bgColor15}
              fontSize={12}
              lineHeight="20px"
              fontWeight={400}
              display="inline"
              pl={2}
            >
              {`Availability: `}{" "}
              <span
                style={{
                  fontSize: 12,
                  fontWeight: 500,
                  color: availability ? "#27bd72" : "#e53935",
                  marginLeft: "6px",
                }}
              >
                {availability ? "Yes" : "No"}
              </span>
            </Typography>
          </Grid>
        )}

        <Grid item xs={6} md={2.5}>
          <Box
            display="flex"
            alignItems="center"
            justifyContent="flex-start"
            m={{ xs: 0, md: "4px 0 0 16px" }}
          >
            <Typography
              sx={{
                fontSize: { xs: 12, md: 12 },
                fontWeight: { xs: 400, md: 500 },
                color: { xs: greyColor50, md: greyColor40 },
                m: { xs: "0 15px 0 15px", md: 0 },
              }}
            >
              {lastUpdateDate
                ? moment(lastUpdateDate)?.format("Do MMM YYYY, hh:mm A")
                : "-"}
            </Typography>
          </Box>
        </Grid>

        <Grid item xs={6} md={1.3}>
          <Box
            display="flex"
            alignItems={{ xs: "flex-start", md: "center" }}
            justifyContent={{ xs: "flex-start", md: "center" }}
          >
            <Box
              sx={{
                ...styles.statusChip(
                  getColorChip(
                    moment(lastUpdateDate)?.isAfter(moment(lastImportDate))
                      ? "pending"
                      : isSynced
                      ? "yes"
                      : "no"
                  )
                ),
                // fontSize: moment(lastUpdateDate)?.isAfter(moment(lastImportDate)) ? '12px' : '12px'
                // ml: 2,
              }}
            >
              {isSynced
                ? moment(lastUpdateDate)?.isAfter(moment(lastImportDate))
                  ? "Update Required"
                  : "Synced"
                : "Not Synced"}
            </Box>
          </Box>
        </Grid>

        <Grid item xs={6} md={2.4}>
          <Box
            display="flex"
            alignItems="center"
            justifyContent="flex-start"
            m={{ xs: "0 0 0 15px", md: "4px 0 0 16px" }}
          >
            {moment(lastUpdateDate)?.isAfter(moment(lastImportDate)) ? (
              <DateWithTooltip
                date={
                  lastImportDate
                    ? moment(lastImportDate)?.format("Do MMM YYYY, hh:mm A")
                    : "-"
                }
                message="Product not synced since the last update. Select the product and use the 'Multi Product Push' button to sync the product to the sub-branch."
              />
            ) : (
              <Typography
                sx={{
                  fontSize: { xs: 12, md: 12 },
                  fontWeight: { xs: 400, md: 500 },
                  color: greyColor40,
                  m: { xs: "0 15px 0 auto", md: 0 },
                }}
              >
                {lastImportDate
                  ? moment(lastImportDate)?.format("Do MMM YYYY, hh:mm A")
                  : "-"}
              </Typography>
            )}
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default MultiPushProductCard;

const PriceInfo = ({ originalPrice, salePrice }) => {
  return (
    <Box display={"flex"} flexDirection={"row"} gap={1} pl={{ xs: 0, md: 0 }}>
      <Typography variant="body1" sx={styles.originalPriceText}>
        {originalPrice === salePrice ? "" : `₹${originalPrice}`}
      </Typography>

      <Typography variant="body1" sx={styles.salePriceText}>
        ₹{salePrice}
      </Typography>

      <Box
        sx={{ ...styles.statusBoxChip(getColorChip("processing")), mt: "2px" }}
      >
        <Typography
          variant="body1"
          color={heroSectionText}
          fontSize="11px"
          fontWeight={600}
          m="6px 0 0 0px !important"
          sx={{ display: "inline", lineHeight: "10px" }}
        >
          {Math.round(calculatePercentageOff(originalPrice, salePrice))}%
        </Typography>
      </Box>
    </Box>
  );
};

// const DateWithTooltip = ({ date }) => {
//   const BootstrapTooltip = styled(({ className, ...props }) => (
//     <Tooltip {...props} arrow classes={{ popper: className }} />
//   ))(({ theme }) => ({
//     [`& .${tooltipClasses.arrow}`]: {
//       color: blackShade05,
//     },
//     [`& .${tooltipClasses.tooltip}`]: {
//       fontSize: 11,
//       textAlign:'center',
//       lineHeight:'18px',
//       backgroundColor: blackShade05,
//     },
//   }));

//   return (
//     <>
//       <BootstrapTooltip  title="Product not synced since the last update. Select the product and use the 'Multi Product Push' button to sync the product to the sub-branch.">
//         <Box
//           sx={{
//             display: "flex",
//             alignItems: "center",
//             gap: 0.5,
//             color: outOfStockColor,
//             position: "relative",
//           }}
//         >
//           <Typography
//             sx={{
//               fontSize: { xs: 12, md: 12 },
//               fontWeight: { xs: 400, md: 500 },
//               color: outOfStockColor,
//               textDecoration: "underline",
//             }}
//           >
//             {date}
//           </Typography>

//           <ErrorIcon />
//         </Box>
//       </BootstrapTooltip>
//     </>
//   );
// };

const styles = {
  checkbox: {
    p: 0,
    transform: "scale(1.3)",
    "&.Mui-checked": {
      color: greyColor8,
    },
  },

  imgBox: {
    borderRadius: "4px",
    border: "1px solid #e5e9f0",
    p: "5px",
  },

  imgContainer: {
    backgroundColor: whiteColor,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: { xs: "25px", md: "35px !important" },
    height: { xs: "25px", md: "35px !important" },
    objectFit: "contain",
  },

  ondcStatusTag: {
    width: "55px",
    display: { xs: "inline", md: "flex" },
    alignItems: "center",
    justifyContent: "center",
    fontSize: { xs: 13, md: 12 },
    fontWeight: 500,
    lineHeight: "22px",
    borderRadius: "50px",
    p: { xs: "0 8px", md: "1px 13px" },
  },

  statusChip: (data) => ({
    backgroundColor: data.bgColor,
    textAlign: "center",
    color: data.color,
    fontWeight: 500,
    fontSize: 10.5,
    lineHeight: 1.5,
    p: "2px 13px",
    borderRadius: "3px",
    width: "max-content",
  }),

  statusBoxChip: (data) => ({
    backgroundColor: data.bgColor,
    color: data.color,
    fontWeight: 500,
    fontSize: 12,
    lineHeight: 1.5,
    p: "2px 4px",
    borderRadius: "4px",
    width: "max-content",
  }),

  originalPriceText: {
    color: oldPriceColor,
    fontSize: 12,
    lineHeight: "15px",
    fontWeight: 400,
    mt: { xs: "6px !important", md: "7px !important" },
    textDecoration: "line-through",
    display: "inline",
  },

  salePriceText: {
    display: "inline",
    color: blueColor04,
    fontSize: 13,
    lineHeight: "15px",
    fontWeight: 600,
    m: { xs: "6px", md: "6px 0 0 0px" },
    mr: 1,
  },

  pushProductBtn: {
    padding: { md: "3px 6px", xs: "3px 14px" },
    fontSize: { md: "11px", xs: "11px" },
    fontWeight: 600,
    color: { xs: mobilePrimary, md: blueColor04 },
    backgroundColor: whiteColor,
    border: {
      xs: `1.5px solid ${mobilePrimary}`,
      md: `1.5px solid ${blueColor04}`,
    },
    ml: { xs: "auto", md: 0 },
    mr: { xs: 2, md: 0 },
    whiteSpace: "nowrap",
    "&:hover": {
      border: {
        xs: `1.5px solid ${mobilePrimary}`,
        md: `1.5px solid ${blueColor04}`,
      },
      color: { xs: mobilePrimary, md: blueColor04 },
      backgroundColor: whiteColor,
    },
    "&.Mui-disabled": {
      border: "none",
    },
  },

  mobileSelectAllBox: {
    display: "flex",
    alignItems: "center",
    gap: 1.4,
    padding: "8px 15px",
    backgroundColor: greyColor42,
    borderRadius: "6px 6px 0 0",
    mb: 1,
  },
};
